import { render, staticRenderFns } from "./CarrierDestinationInfoCard.vue?vue&type=template&id=113f06de&scoped=true&"
import script from "./CarrierDestinationInfoCard.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f06de",
  null
  
)

export default component.exports